import { Injectable } from "@angular/core";
import { UserCache } from "src/app/services/user-cache";
import { WebApiClient } from "src/app/services/web-api-client.service";
import { WebApiService } from "src/app/services/web-api.service";
import { PageData2 } from "src/app/shared/models/page-data";

@Injectable({
  providedIn: 'root'
})

export class SystemSettingExportImportService {

  private api: WebApiService;
  clinicId = 0;

  constructor(private webApiFactory: WebApiClient) {
    this.api = this.webApiFactory.createHisService('');
    this.clinicId = UserCache.getLoginClinicId();
  }

  async GetAll(query: exportSystemQuery, type: exportItemTypeDto, operating?: string): Promise<PageData2<any>> {
    var o = Object.assign({}, query);
    o.clinicId = this.clinicId
    let url = type.listUrl
    if (operating == 'export') {
      url = type.exportUrl
    }
    if (type.value == "Parameter") {
      o.hideDefault = true;
    }
    return this.api.get(url, o).toPromise<PageData2<any>>()
  }

  async PostAll(data: any, type: exportItemTypeDto): Promise<any> {
    let url = type.importUrl
    return this.api.post(url, data).toPromise<any>()
  }
}

export class exportSystemQuery {
  clinicId?: number;
  pageSize?: number;
  pageSkipNo?: number;
  hideDefault?: boolean;
};

export interface exportItemTypeDto {
  value: string;
  text: string;
  listUrl?: string;
  exportUrl?: string;
  importUrl?: string;
  checked: boolean;
  total?: number;
};

export interface ExportDataDto<T = any> {
  customerCode: string;
  exportTime: Date;
  data: {
    [key: string]: T;
  };
}


export const exportItemTypes: exportItemTypeDto[] = [
  {
    value: "Parameter",
    text: "系統參數",
    listUrl: "system/ParameterProfile/getAll",
    exportUrl: "system/ParameterProfile/export",
    importUrl: "system/ParameterProfile/import",
    checked: false
  }, {
    value: "setting",
    text: "集團系統代碼",
    listUrl: "system/SystemCode/GetAllFormCompanyMaintain",
    exportUrl: "system/SystemCode/GetAllFormCompanyMaintain",
    importUrl: "system/SystemCode/ImportAll",
    checked: false
  }, {
    value: "cmsReport",
    text: "cms樣版代碼",
    listUrl: "system/Report/GetExportAll",
    exportUrl: "system/Report/GetExportAll",
    importUrl: "system/Report/ImportAll",
    checked: false
  }, {
    value: "system-number",
    text: "院內取號規則",
    listUrl: "system/systemNumber/getAll",
    exportUrl: "system/SystemCode/ExportSystemNumberAll",
    importUrl: "system/SystemCode/ImportSystemNumberAll",
    checked: false
  }, {
    value: "registersNumberRule",
    text: "掛號取號規則",
    listUrl: "system/RegisterNumberRule/GetAllRuleSetList",
    exportUrl: "system/RegisterNumberRule/GetAllRuleSetList",
    importUrl: "system/RegisterNumberRule/ImportRegisterRuleSets",
    checked: false
  }

]
